import * as React from 'react';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ComplexValue } from 'ui/common/types';
import { CodeSelectorTileView, CodeSelectorTileViewProps } from 'app/components/code-selector-tile-view';

import type { JSX } from "react";

export interface PreselectedCodeTileViewProps extends CodeSelectorTileViewProps {
  codeDataTag: string;
  extraFooterButton?: (onCloseCallback: (onClose: void) => void) => JSX.Element;
}

export class PreselectedCodeTileView extends React.PureComponent<PreselectedCodeTileViewProps, any> {

  private onAddDocumentItem = (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => {

    const { codeDataTag } = this.props;

    const code = options.initialValues.primaryKey as ComplexValue<number>;

    const initialValues = codeDataTag && {
      [codeDataTag]: [code]
    };

    this.props.onAddDocumentItem(selectAddedItem, {
        childId: undefined, //Numerator, ignore the code id from code selector tile view.
        initialValues
    });
  };

  public render() {
    const { rowClassName, extraFooterButton } = this.props;
    
    return (
      <CodeSelectorTileView {...this.props}
        onAddDocumentItem={this.onAddDocumentItem}
        existingKeys={[]}
        rowClassName={rowClassName || 'col-12'}
        extraFooterButton={extraFooterButton}
      />
    );
  }
}
